import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterSettings',
  standalone: true,
})
export class FilterSettingsPipe implements PipeTransform {
  transform(
    items: any[],
    name: string,
    withdraw: any,
    deposit: any,
    daemon: any,
    parent: string
  ): any[] {
    return items.filter((item) => {
      if (item.parentCurrency === '-') {
        console.log(item.parentCurrency, item);
      }

      if (withdraw !== 'any' && item.withdrawActive !== withdraw) {
        return false;
      }
      if (deposit !== 'any' && item.depositActive !== deposit) {
        return false;
      }
      if (daemon !== 'any' && item.daemonStatus !== daemon) {
        return false;
      }
      if (parent !== 'Any' && item.parentCurrency !== parent) {
        return false;
      }

      if (name) {
        const nameStr = name.toLowerCase();
        const itemSymbol = item.symbol.toLowerCase();
        const itemName = item.name.toLowerCase();
        if (!(itemSymbol.includes(nameStr) || itemName.includes(nameStr))) {
          return false;
        }
      }
      return true;
    });
  }
}
